import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { api, ApiFailure } from '../api'
import { useAuth } from '../auth'

export default function ChangePassword() {
  const { user, refresh } = useAuth()
  const navigate = useNavigate()
  const [currentPassword, setCurrent] = useState('')
  const [newPassword, setNew] = useState('')
  const [confirm, setConfirm] = useState('')
  const [msg, setMsg] = useState<{ kind: 'ok' | 'error'; text: string } | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setMsg(null)

    if (newPassword !== confirm) {
      setMsg({ kind: 'error', text: 'The two new passwords do not match.' })
      return
    }

    setBusy(true)
    try {
      await api.post('/api/auth/change-password', { currentPassword, newPassword })
      // The server revokes every session, including this one.
      await refresh()
      navigate('/login', { replace: true })
    } catch (err) {
      setMsg({ kind: 'error', text: err instanceof ApiFailure ? err.message : 'Could not change the password.' })
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <div className="page-head">
        <h2>Change password</h2>
        <p>You will be signed out of every device and will need to sign in again.</p>
      </div>

      {user?.mustChangePassword && (
        <div className="msg warn">
          This account is still on a temporary password. Set your own before continuing.
        </div>
      )}
      {msg && <div className={`msg ${msg.kind}`}>{msg.text}</div>}

      <form className="panel" onSubmit={(e) => void submit(e)}>
        <div className="grid two">
          <div className="field">
            <label htmlFor="cur">Current password</label>
            <input id="cur" type="password" value={currentPassword} autoComplete="current-password"
              onChange={(e) => setCurrent(e.target.value)} required />
          </div>
          <div />
          <div className="field">
            <label htmlFor="new">New password</label>
            <input id="new" type="password" value={newPassword} autoComplete="new-password"
              onChange={(e) => setNew(e.target.value)} required />
            <span className="hint">At least 8 characters, not all digits.</span>
          </div>
          <div className="field">
            <label htmlFor="conf">Confirm new password</label>
            <input id="conf" type="password" value={confirm} autoComplete="new-password"
              onChange={(e) => setConfirm(e.target.value)} required />
          </div>
        </div>
        <div className="actions">
          <button type="submit" disabled={busy}>Change password</button>
        </div>
      </form>
    </>
  )
}
